module.exports = __webpack_public_path__ + "static/media/ipause.ff4b2739.svg";